import { formatMultiplier } from '../../features/settlementClassification/appliedRule';

/**
 * 저장된 요율(%) 표시 — 소수 둘째 자리까지 그대로(예외 요율은 45.55% 처럼 둘째 자리까지 저장된다).
 * 첫째 자리 이하 값은 예전 표시와 같다(30% · 12.5%). 둘째 자리 값은 예전엔 반올림돼 다른 요율로 보였다.
 * 평균 요율(effectiveCommissionRate)은 계산값이라 예전처럼 첫째 자리(formatPercent).
 */
export const formatStoredPercent = (value: number) => `${Number((Math.round(Number(value) * 100) / 100).toFixed(2))}%`;

/**
 * 배수 예외가 걸린 행의 「정산 비율」에 서버 exceptionMultiplier 를 붙인다(예: 「40% ×1.2」). 금액은 서버 값 그대로다 —
 * 정산 비율 칸의 요율은 원래 요율이라 배수를 빼면 금액과 설명이 맞지 않는다. 배수가 없으면 빈 문자열(예전 표시 그대로).
 */
export const withMultiplier = (multiplier: unknown) => {
    const text = formatMultiplier(multiplier);
    return text ? ` ${text}` : '';
};

/**
 * 행의 「정산 비율」 뒤에 붙일 배수 — 「항상 IN 요율의 배수」(서버 exceptionMode === 'inMultiplier') 행은
 * 정산 비율 칸의 요율이 IN 요율이라 「40% (IN ×1.2)」, 배수 1 이면 「40% (IN)」. 그 밖은 withMultiplier 그대로.
 */
export const withRowMultiplier = (row: { exceptionMultiplier?: unknown; exceptionMode?: unknown } | null | undefined) => {
    if (row?.exceptionMode === 'inMultiplier') {
        const text = row.exceptionMultiplier === 1 ? null : formatMultiplier(row.exceptionMultiplier);
        return text ? ` (IN ${text})` : ' (IN)';
    }
    return withMultiplier(row?.exceptionMultiplier);
};
